const DOCUMENT = 'SESSIONS_PAST_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_GROUP_REQUEST: DOCUMENT + 'LOAD_GROUP_REQUEST',
  LOAD_GROUP_SUCCESS: DOCUMENT + 'LOAD_GROUP_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadSessionsPast: data => ({
    type: actions.LOAD_REQUEST,
    payload: data,
  }),

  loadSessionsPastSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadGroupSessionsPast: data => ({
    type: actions.LOAD_GROUP_REQUEST,
    payload: data,
  }),

  loadGroupSessionsPastSuccess: data => ({
    type: actions.LOAD_GROUP_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
